import React from 'react';
import { Typography } from '@tvg/fuse/typography';
import { NameProps } from './NameProps';
import styles from './Name.module.css';

function Name({ brand, name }: NameProps) {
  return (
    <Typography tag="h1" size="4" className={styles.container}>
      {brand && (
        <span className={styles.brand} dangerouslySetInnerHTML={{ __html: brand }} data-testid="product_brand" />
      )}
      <span dangerouslySetInnerHTML={{ __html: name }} data-testid="product_title" />
    </Typography>
  );
}

export default Name;
